module.exports = __webpack_public_path__ + "static/assets/e99632d435f2c4ecbd5a8eff04d7f081.svg";